// extracted by mini-css-extract-plugin
export default {"myModal":"Modal_myModal__aFao9","Content":"Modal_Content__Ipsj3","active":"Modal_active__oIOpg"};